module.exports = __webpack_public_path__ + "img/xtractive-graphiteGreen.e66a9c65.png";